import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBell = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M5.307 5.25c.204-2.049 1.96-3.5 4.06-3.5h1.266c2.1 0 3.857 1.451 4.06 3.5l.424 4.5c.154 1.544.817 3.11 1.89 4.25.537.57.125 1.75-.666 1.75H3.659c-.79 0-1.203-1.18-.667-1.75 1.073-1.14 1.737-2.706 1.89-4.25l.425-4.5Zm2.443 10.5h4.5V16a2.25 2.25 0 0 1-4.5 0v-.25Z"
	})]
});
const ForwardRef = forwardRef(SvgBell);
export { ForwardRef as ReactComponent };
